import React from "react";

const Report = () => {
 
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between !mt-0 ">
        <h1 className="text-2xl font-bold text-light-darkGrey font-roboto cursor-default">
          Report
        </h1>
      </div>
      {/* Add Report page content here */}
      <p>Report page content will go here.</p>
    </div>
  );
};

export default Report; 